<div>
  <div class="d-flex justify-content-between align-items-center mb-1">
    <p class="fw-SemiBold f-size-14 mb-0">{{ title }}</p>
    <button
      *ngIf="isChangeable"
      class="btn btn-link fw-bold f-color-vibrant-blue f-size-14 text-decoration-none"
      [disabled]="isComponentDisabled"
      (click)="isOpen = !isOpen"
    >
      {{ isOpen ? "გაუქმება" : "შეცვლა" }}
    </button>
    <button
      *ngIf="isDeletable"
      class="btn btn-link fw-bold f-color-vibrant-blue f-size-14 text-decoration-none"
    >
      წაშლა
    </button>
  </div>
  <div *ngIf="isOpen">
    <ng-content select="[body]"></ng-content>
  </div>
  <div *ngIf="!isOpen">
    <ng-content select="[header]"></ng-content>
  </div>
</div>
